import React, { useState, useEffect, useRef, useCallback } from 'react';
import styles from '../../../styles/orderAnimation/orderAnimationThree.module.scss';
import { ReactComponent as Pan1 } from '../../../assets/animation/pan1.svg';
import { ReactComponent as Pan2 } from '../../../assets/animation/pan2.svg';
import { ReactComponent as Pan3 } from '../../../assets/animation/pan3.svg';
import { ReactComponent as Pan4 } from '../../../assets/animation/pan4.svg';

const potImages = [Pan1, Pan2, Pan3, Pan4];

const preloadImages = () => {
  // potImages.forEach((image) => {
  //   const img = new Image();
  //   img.src = image;
  // });
  potImages.forEach((image) => {
    <image className={styles.primaryColor} />;
  });
};

const OrderAnimationThree = () => {
  const [currentPotIndex, setCurrentPotIndex] = useState(0);
  const animationRef = useRef(null);
  const lastTimestampRef = useRef(null);

  useEffect(() => {
    preloadImages();

    const animate = (timestamp) => {
      if (!lastTimestampRef.current) {
        lastTimestampRef.current = timestamp;
      }

      if (timestamp - lastTimestampRef.current >= 90) {
        setCurrentPotIndex((prevIndex) => (prevIndex + 1) % potImages.length);
        lastTimestampRef.current = timestamp;
      }

      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationRef.current);
  }, []);

  const animateCallback = useCallback((timestamp) => {
    if (!lastTimestampRef.current) {
      lastTimestampRef.current = timestamp;
    }

    if (timestamp - lastTimestampRef.current >= 90) {
      setCurrentPotIndex((prevIndex) => (prevIndex + 1) % potImages.length);
      lastTimestampRef.current = timestamp;
    }

    animationRef.current = requestAnimationFrame(animateCallback);
  }, []);

  useEffect(() => {
    animationRef.current = requestAnimationFrame(animateCallback);
    return () => cancelAnimationFrame(animationRef.current);
  }, [animateCallback]);

  return (
    <div className={styles.OrderAnimationThree_main}>
      <img src={potImages[currentPotIndex]} alt="pan" />
    </div>
  );
};

export default OrderAnimationThree;
